import { ContentService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';
import { EVENTS, ContentModuleTypes } from '@DavisDigital/interfaces';

enum Tabs {
    PREZI         = "prezi",
    SLIDE_SHARE   = "slideShare",
    VOICE_THREAD  = "voiceThread",
    GOOGLE_SLIDES = "googleSlides"
}

class ImportContentModalController {
    
    // @attributes
	public lessonId:string;
	public position: number;
    public close: Function;
    
    private domParser = new DOMParser();

	// @state
	public state$ = {
        'activeTab': Tabs.GOOGLE_SLIDES,
        'error': null
    };
    
    public form$ = {
        content: "",
    };
	
    
	// @ngInject
	constructor(
	    private $log            : ng.ILogService,
		public contentService	: ContentService, 
		public observerService	: ObserverService,
	){}
	

    //TODO: drive HTMl-tabs with Angular 
	public selectTab = (newTab:Tabs) => {
	    
	    if(this.state$.activeTab === newTab){
	        return;
	    }
	    
	    this.state$.activeTab = newTab;
	    this.form$.content = "";
	    this.clearError();
	};
	
	private setError(error: string){
	    this.state$.error = error;
	}
	
	private clearError(){
	    this.state$.error = null;
	}
	
	public submit = () => {
	    this.clearError();
	 
	    try {
	        
	        if(!this.form$.content){
	            throw("Please add the embedding markup");
	        }
	        
	        let url = this.parseEmbeddedMarkup( this.form$.content.replace(/(src|href)="\/\//g,'$1="https://'));
	        let isValid = this.validateURL(url, this.state$.activeTab );
	        if(!isValid){
	            throw("Something is not right, the parent function should have thrown or return true");
	        }
	        
	        
	        let contentModule = this.contentService.newContentModule(ContentModuleTypes.EMBEDDED, this.position);
	        contentModule.bodyHTML = this.createShareURLEmbeddedMarkup(url);
	        
	        this.observerService.notifyById( 
	            EVENTS.ADD_CONTENT, 
	            this.lessonId, 
	            contentModule
	        );

	        this.closeModal();
	    } 
	    catch(e) {
	        this.setError(e);
	    }
	}

	public closeModal = () =>{
		this.close();
	}
	
	// Utity
	
   /**
	 * This function takes
	 * 
	 * Either some markups like 
	 * 
	 * Google Slide:
	 * <iframe src="https://docs.google.com/presentation/d/e/2PACX-1vR3x5e3WLeVQsoom7G9XDuBiA259ba8ZbCk2VVGZd8bpnI1Z_r-YHrpaMOMD8oQDz91zKk7HOjjuYqn
	 *      /embed?start=false&loop=false&delayms=3000" 
	 *      frameborder="0" width="960" height="569" allowfullscreen="true" 
	 *      mozallowfullscreen="true" webkitallowfullscreen="true">
	 * </iframe>
	 * 
	 * Slide Share: 
	 * <iframe src="https://www.slideshare.net/slideshow/embed_code/key/EP6Yf9I2idPXCb"
	 *      width="597" height="486" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" style="border:1px solid #CCC; border-width:1px; 
	 *      margin-bottom:5px; max-width: 100%;" allowfullscreen> 
	 * </iframe> 
	 * <div style="margin-bottom:5px"> 
	 *      <strong> 
	 *          <a href="https://www.slideshare.net/socialogilvy/whats-next-social-media-trends-2020"
	 *              title="What&#x27;s Next: Social Media Trends 2020 " target="_blank">What&#x27;s Next: 
	 *              Social Media Trends 2020 </a> 
	 *      </strong> from 
	 *      <strong>
	 *          <a href="https://www.slideshare.net/socialogilvy" target="_blank">Ogilvy Consulting</a>
	 *      </strong> 
	 * </div>
	 * 
	 * Voice Thread:
	 * <iframe width="480" height="270" 
	 *      src="https://voicethread.com/app/player/?threadId=699465" frameborder="0" 
	 *      allowusermedia allowfullscreen allow="camera https://voicethread.com; 
	 *      microphone https://voicethread.com; fullscreen https://voicethread.com;">
	 * </iframe>
	 * 
	 * 
	 * Prezi :
	 * <iframe src="https://prezi.com/p/rvxos0z15v1t/embed/"
	 *      id="iframe_container" frameborder="0" 
     *      webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" 
     *      allow="autoplay; fullscreen" height="315" width="560">
     * </iframe>
	 * 
	 * 
	 * 
	 * and returns an instance of URL Class;
	  {
	    hash: ""
        host: "docs.google.com"
        hostname: "docs.google.com"
        href: "https://docs.google.com/presentation/d/e/2PACX-1vR3x5e3WLeVQsoom7G9XDuBiA259ba8ZbCk2VVGZd8bpnI1Z_r-YHrpaMOMD8oQDz91zKk7HOjjuYqn%20*%20%20%20%20%20%20/embed?start=false&loop=false&delayms=3000"
        origin: "https://docs.google.com"
        password: ""
        pathname: "/presentation/d/e/2PACX-1vR3x5e3WLeVQsoom7G9XDuBiA259ba8ZbCk2VVGZd8bpnI1Z_r-YHrpaMOMD8oQDz91zKk7HOjjuYqn%20*%20%20%20%20%20%20/embed"
        port: ""
        protocol: "https:"
        search: "?start=false&loop=false&delayms=3000"
        searchParams: URLSearchParams {}
        username: "
	  }
	 * 
	 * 
	*/
    private parseEmbeddedMarkup(htmlMarkup: string): URL|never {

        try{
            //try to parse the embedded-html-markup, if it's 
            let element = this.domParser.parseFromString(htmlMarkup, 'text/html');
            if(element.querySelector('parsererror')){
                throw("Not valid markup, unable to parse");
            }
            //find first iframe and extract the contents of src attribute
            var src = element.querySelector('iframe')?.getAttribute('src');
            if(!src){
                throw("unable to find the value for src attribute");
            }

            return new URL(src); //this can also throw if the src is not a vald url;
        } 
        catch(e){
            this.$log.error("Error in parseAndCreateURL: unable to extract URL from provided-markup Error: ", e);
            throw("Error in the markup, could not parse, please check and retry");
        }
    }
	
	private validateURL(url: URL, provider = Tabs.GOOGLE_SLIDES ): boolean | never{
	    
	    switch( provider ){
	        case Tabs.GOOGLE_SLIDES:
	            return this.validateGoogleSlideUrl(url);
	        case Tabs.SLIDE_SHARE:
	            return this.validateSlideShareUrl(url);
	        case Tabs.VOICE_THREAD:
                return this.validateVoiceThreadUrl(url);	            
	        case Tabs.PREZI:
    	        return this.validatePraziUrl(url);
	    }
	}
	
	private validateGoogleSlideUrl(url:URL): true | never {
	    
        /**
         {
            host: "docs.google.com"
            href: "https://docs.google.com/presentation/d/e/2PACX-1vR3x5e3WLeVQsoom7G9XDuBiA259ba8ZbCk2VVGZd8bpnI1Z_r-YHrpaMOMD8oQDz91zKk7HOjjuYqn%20%20%20%20%20%20%20/embed?start=false&loop=false&delayms=3000"
            origin: "https://docs.google.com"
            pathname: "/presentation/d/e/2PACX-1vR3x5e3WLeVQsoom7G9XDuBiA259ba8ZbCk2VVGZd8bpnI1Z_r-YHrpaMOMD8oQDz91zKk7HOjjuYqn%20%20%20%20%20%20%20/embed"
            search: "?start=false&loop=false&delayms=3000" 
         }
	    */
	    if( !url.host?.includes?.('docs.google.com') ){
	        throw("Not a valid google-slides URL");
	    }
	    if( !url.pathname?.includes?.('/presentation/') ){
	        throw("Not a valid Presentation");
	    }
	    if( !url.pathname?.includes?.('embed') ){
	        throw("Not a valid embedded URL");
	    }
	    
	    return true;
	}

	private validateSlideShareUrl(url:URL): true | never {
	    
	    /**
	     {
	        host: "www.slideshare.net"
            href: "https://www.slideshare.net/slideshow/embed_code/key/EP6Yf9I2idPXCb"
            origin: "https://www.slideshare.net"
            pathname: "/slideshow/embed_code/key/EP6Yf9I2idPXCb"
	     }
	    */
	    if( !url.host?.includes?.('slideshare.net') ){
	        throw("Not a valid slides-share URL");
	    }
	    if( !url.pathname?.includes?.('/slideshow/') ){
	        throw("Not a valid Presentation");
	    }
	    if( !url.pathname?.includes?.('/embed_code/') ){
	        throw("Not a valid embedded URL");
	    }
	    return true;
	}
	
	private validateVoiceThreadUrl(url:URL): true | never {
	    
	    /**
	     {
	        host: "voicethread.com"
            href: "https://voicethread.com/app/player/?threadId=699465"
            origin: "https://voicethread.com"
            pathname: "/app/player/"
            search: "?threadId=699465"
	     }
	    */
	    if( !url.host?.includes?.('voicethread.com') ){
	        throw("Not a valid voice-thread URL");
	    }
	    // if there's no 'threadId' in the URl or if the value is empty
	    if( !url.searchParams?.has('threadId') || !url.searchParams?.get('threadId') ){
	        throw("Not a valid Voice-thread");
	    }
	    if( !url.pathname?.includes?.('/app/player/') ){
	        throw("Not a valid embedded URL");
	    }
	    return true;
	}
	
	private validatePraziUrl(url:URL): true | never {
	    
	    /**
	     {
	        host: "prezi.com"
            href: "https://prezi.com/p/rvxos0z15v1t/embed/"
            origin: "https://prezi.com"
            pathname: "/p/rvxos0z15v1t/embed/"
	     }
	    */
	    if( !url.host?.includes?.('prezi.com') ){
	        throw("Not a valid Prazi URL");
	    }
	    if( !url.pathname?.includes?.('/embed/') ){
	        throw("Not a valid embedded URL");
	    }
	    
	    return true;
	}
	
	private createShareURLEmbeddedMarkup(url: URL){
	    
	    return  `<iframe src="${url.href}" class="embedded" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>`;
	}
	
}

class ImportContentModal {
	
	public restrict: string = 'E';
	public scope = {};
	
	public bindToController: any = {
		lessonId:'=',
		position: "=",
		close: '=', //callback-function, injected via ModalService 
	};

	public controller = ImportContentModalController;
	public controllerAs = 'importContentModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/import-content-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImportContentModal };
